// extracted by mini-css-extract-plugin
export default {"container":"DashBoardAdmin_container__8JuW0","flex":"DashBoardAdmin_flex__Ys4iY","text":"DashBoardAdmin_text__S4Eqz","subtext":"DashBoardAdmin_subtext__hJJnH"};